var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { width: _vm.dialogWidth, "max-width": "500px" },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.save.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        {
          staticClass: "resizable-card",
          class: { "no-select": _vm.resizing },
          style: { height: _vm.dialogHeight + "px" },
        },
        [
          _c(
            "v-card-title",
            [
              _c("span", { staticClass: "headline" }, [
                _vm._v("Store Bundle Config"),
              ]),
              _c("v-spacer"),
              _c(
                "v-card",
                { staticClass: "mb-5", attrs: { flat: "" } },
                [
                  _c("v-switch", {
                    attrs: {
                      label: "Active",
                      color: "success",
                      "hide-details": "",
                    },
                    model: {
                      value: _vm.model.active,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "active", $$v)
                      },
                      expression: "model.active",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-text",
            { staticClass: "resizable-card__body" },
            [
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "12", sm: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Bundle", "hide-details": "" },
                        model: {
                          value: _vm.model.bundle,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model,
                              "bundle",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "model.bundle",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "12", sm: "12" } },
                    [
                      _c("v-text-field", {
                        directives: [
                          { name: "ascii-only", rawName: "v-ascii-only" },
                        ],
                        attrs: {
                          label: "Google Store Id:",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.model.google_store_id,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model,
                              "google_store_id",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "model.google_store_id",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "12", sm: "12" } },
                    [
                      _c("v-text-field", {
                        directives: [
                          { name: "ascii-only", rawName: "v-ascii-only" },
                        ],
                        attrs: {
                          label: "Google Store Option Id:",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.model.google_store_option_id,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model,
                              "google_store_option_id",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "model.google_store_option_id",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "12", sm: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Payer Points:", "hide-details": "" },
                        model: {
                          value: _vm.model.points,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "points", _vm._n($$v))
                          },
                          expression: "model.points",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "resizable-card__actions" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.save },
                },
                [_vm._v(" Save ")]
              ),
            ],
            1
          ),
          _c("div", {
            staticClass: "resize-handle",
            on: { mousedown: _vm.startResize },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }